import { LabelLanguage } from "../interfaces";
import http from "./httpService";

//EndPoints
const endpointPath = "RestSearch.svc";

//Routes
const getLabelLanguage = "GetLabelLanguage";

const GetLabelLanguageURL = (languageCode: string): string => {
  let parameters = [];

  if (languageCode) {
    parameters.push(`languageCode=${languageCode}`);
  }

  return `${endpointPath}/${getLabelLanguage}?${parameters.join("&")}`;
};

export const GetLabelLanguage = async (languageCode: string) => {
  const response = await http.get(GetLabelLanguageURL(languageCode));

  return response.data;
};
